import { useAuth } from "../../hooks/useAuth";
import { Navigate, useLocation } from "react-router-dom";
import { buildLoginUrl } from "../../utils/redirect";

const AuthGuard = ({ children }) => {
    const auth = useAuth();
    const location = useLocation();

    if (auth.token) {
        return <>{children}</>;
    } else {
        const token = localStorage.getItem("token");
        if (token !== null) {
            return <>{children}</>;
        }
    }

    const target = location.pathname + location.search + location.hash;
    return <Navigate to={buildLoginUrl(target)} replace />;
};

export default AuthGuard;
